module.exports = __webpack_public_path__ + "img/pd-img22.aeeec50a.png";